import axios from 'axios'
import util from '@/libs/util'
import { Message, Modal } from 'view-design'
import { getToken } from './util'

class HttpRequest {
  constructor (baseUrl = '1111') {
    this.baseUrl = baseUrl
    this.queue = {}
  }
  getInsideConfig () {
    const config = {
      baseURL: this.baseUrl,
      headers: {
        //
      }
    }
    return config
  }
  destroy (url) {
    delete this.queue[url]
    if (!Object.keys(this.queue).length) {
      // Spin.hide()
    }
  }
  interceptors (instance, url) {
    // 请求拦截
    instance.interceptors.request.use(config => {
      // 添加全局的loading...
      if (!Object.keys(this.queue).length) {
        // Spin.show() // 不建议开启，因为界面不友好
      }
      config.headers['Authorization'] = `Bearer ${getToken()}`;
      this.queue[url] = true
      return config
    }, error => {
      return Promise.reject(error)
    })
    // 响应拦截
    instance.interceptors.response.use(res => {
      this.destroy(url)
      const { data, status } = res
      return { data, status }
    }, error => {
      this.destroy(url)
      let text = error
      if (error.response !== undefined) {
        if (error.response.status === 401) {
         let redirect = util.getQueryVariable('redirect')
          Modal.confirm({
            title: '登录信息过期，请重新登录!',
            cancelText: '取消',
            okText: '重新登录',
            closable: false,
            onOk: () => {
              util.rmItem('loginuser');
              util.rmItem('jwt');
              util.rmItem('auth');
              util.rmItem('display');
              util.rmItem('avatar');
              util.rmItem('TOKEN');
              util.rmItem('token');
              localStorage.clear()
              if (location.hash.indexOf('/login') === -1) {
                // 跳转
                window.location.href = '/#/login?redirect=' + redirect
                // location.reload()
              } else {
                // 刷新
                location.reload()
              }
            }
          })
          return Promise.reject(error)
        } else if (error.response.status === 403) {
          text = '对不起，您没有该接口访问权限，请联系管理员'
        } else {
            text = error.response.data.msg
        }
      }
      if (location.hash.indexOf('/login') > 0) {
        text = '账号或密码错误,请重新输入!'
      }
      Message.error({
        background: true,
        content: text,
        duration: 3
      })
      return Promise.reject(error)
    })
  }
  request (options) {
    const instance = axios.create()
    options = Object.assign(this.getInsideConfig(), options)
    this.interceptors(instance, options.url)
    return instance(options)
  }
}
export default HttpRequest



// WEBPACK FOOTER //
// ./src/libs/axios.js